// ? Style
import styled, { ThemeProvider } from "styled-components";

const Jumbotron = (props) => {
  const theme = {
    image: props.image,
    text: props.text,
  };

  return (
    <Jumbo>
      <ThemeProvider theme={theme}>
        <Image></Image>
      </ThemeProvider>
      <Text>
        <h1>Ignite.</h1>
        <h4>{props.text}</h4>
      </Text>
    </Jumbo>
  );
};

// ? Styles
const Jumbo = styled.div`
  width: 100%;
  height: 40vh;
  position: relative;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

const Text = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  h1 {
    font-size: 4.5rem;
    font-family: "Abril Fatface", cursive;
    color: #e2e2e2;
  }
  h4 {
    margin-top: 1.3rem;
    font-size: 2rem;
    color: #e2e2e2;
  }
`;
const Image = styled.div`
  background-image: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),
    url(${(props) => props.theme.image});
  height: 40vh;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
`;
export default Jumbotron;
